module.exports = __webpack_public_path__ + "static/media/EmailIcon.73b94a34.svg";